import * as Sentry from "@sentry/react";

/**
 * Report an auth/login failure to Sentry without changing control flow.
 */
export function captureAuthException(
	error: unknown,
	operation: string,
	extra?: Record<string, unknown>,
): void {
	Sentry.captureException(error, {
		tags: { subsystem: "auth", operation },
		extra,
	});
}
